// extracted by mini-css-extract-plugin
export default {"container":"AdminConsole_container__+e6QC","myTab":"AdminConsole_myTab__VVyrV","MuiTab-wrapper":"AdminConsole_MuiTab-wrapper__4hnFK","tabContent":"AdminConsole_tabContent__ZKfMs"};